import { render, staticRenderFns } from "./FrankeLogo.vue?vue&type=template&id=4ec9788c&scoped=true&"
var script = {}
import style0 from "./FrankeLogo.vue?vue&type=style&index=0&id=4ec9788c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9788c",
  null
  
)

export default component.exports